<template>
<div class="settings-staff page noscroll">
	<router-view v-if="path!=='staff'" />
	<template v-else>
		<div class="header">
			<h3>Team members</h3>
			<div class="flex"></div>
			<router-link to="/settings/staff/new" class="btn">
				Add new team member
			</router-link>
		</div>
		<div class="layout-column flex content noscroll">
			<loading v-if="loading" />
			<div class="layout-column flex" v-else-if="!members || members.length===0">
				<span style="margin: auto;">No team members were added yet!</span>
			</div>
			<div v-else class=" scroll">
				<div class="panel-body entries-table">
					<div class="panel-item entry" v-for="m in members" :key="m.member_id" @click="gotoStaff(m.member_id)">
						<div class="cell fullname">
							<span class="cell-title">{{m.first_name + ' ' + m.last_name}}</span>
						</div>
						<div class="cell customer">
							<span class="cell-value">{{m.email}}</span>
						</div>
						<div class="cell">
							<span class="cell-value through">{{getPermissionBrief(m)}}</span>
						</div>
						<div class="cell" style="margin-left: 30px">
							<v-button flat class="small-btn" v-tippy content="Delete member"
							          @click.stop="del(m.member_id)" :disabled="cantDelete(m)"
							          red :icon="require('@/assets/img/delete_icon.svg')" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</template>
</div>
</template>

<script>
import VButton from "@/components/base/v-button";
import API from '@/api';
import Loading from "@/components/Loading";

export default {
	name: "staff", components: {Loading, VButton},
	mixins:[API],
	data(){
		return {
			loading: false,
		}
	},
	computed:{
		path(){
			return this.$route.name
		},
		members(){
			return this.$store.state.staff
		},
	},
	methods:{
		cantDelete(m){
			if (!this.members) return false;
			let l = this.members.filter(x=>this.getPermissionBrief(x)==='Admin');
			return l.length <= 1 && this.getPermissionBrief(m)==='Admin'
		},
		getPermissionBrief(member) {
			if (member.permissions) {
				let p = JSON.parse(member.permissions)
				if (p.admin) return "Admin";
				else if (p.funnels) return "Funnels";
				else if (p.editor) return "Editor";
				else if (p.automations) return "Automations";
				else if (p.orders) return "Orders";
				else if (p.readonly) return "Readonly";
			}
		},
		async load() {
			try {
				this.loading = true;

				let members = await this.api.settings.getStaff();
				if (members.error) {
					this.$error(members)
					return
				}
				this.$store.commit("SET_STAFF", members)

			} catch (e) {
				this.$warn(e)
			} finally {
				this.loading = false;
			}
		},
		async del(id) {
			try {
				if(!confirm("Are you sure you want to delete this team member?")) return;
				// this.loading = true;

				await this.api.settings.deleteStaff(id);

				let i = this.members.findIndex(x=>x.member_id===id);
				if (i>=0) this.members.splice(i, 1);

			} catch (e) {
				this.$warn(e)
			} finally {
				// this.loading = false;
			}
		},
		gotoStaff(id) {
			this.$router.push(`/settings/staff/edit/${id}`)
		}
	},
	mounted() {
		this.load()
	}
}
</script>

<style lang="scss" scoped>
.settings-staff {
	display: flex;
	flex-direction: column;
	.header {
		border-bottom: 1px solid $light-grey;
		border-radius: 0 0 0 0;
	}
}
.entries-table {
	margin: 20px;
}
</style>
